import type { FC } from 'react';
import { cn } from './react';

export const Spinner: FC<{ className?: string }> = ({ className }) => (
  <span
    className={cn(
      'inline-block border-2 aspect-square rounded-full border-t-transparent border-r-transparent bg-transparent animate-spin',
      className,
    )}
  />
);
